import { useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    const form = e.currentTarget;
    const data = new URLSearchParams();
    data.append("email", email);
    try {
      await fetch("https://readdy.ai/api/form/d7abbhtfdd9edovmh120", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-[#1C2B1A] text-white">
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/28bbe5f5-3a79-4a8a-a924-ccc2a95d56db.png"
              alt="ARAVELLA LLC"
              className="h-12 w-auto object-contain brightness-0 invert mb-4"
            />
            <p className="text-white/60 text-sm leading-relaxed">
              Premium outdoor furniture crafted for lasting beauty and comfort. Elevate your outdoor living experience.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://instagram.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://facebook.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-sm"></i>
              </a>
              <a href="https://pinterest.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-white/60 transition-colors cursor-pointer">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-5 text-white/80">
              <a href="#shop">Shop</a>
            </h4>
            <ul className="space-y-3">
              {["All Products", "Chairs", "Tables", "Sofas & Sets", "Accessories"].map(item => (
                <li key={item}>
                  <Link to="/products" className="text-white/50 text-sm hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-5 text-white/80">
              <a href="#company">Company</a>
            </h4>
            <ul className="space-y-3">
              {["About Us", "Reviews", "Contact Us", "Shipping Policy", "Return Policy"].map(item => (
                <li key={item}>
                  <Link to="/reviews" className="text-white/50 text-sm hover:text-white transition-colors">
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-widest mb-5 text-white/80">
              <a href="#newsletter">Newsletter</a>
            </h4>
            <p className="text-white/50 text-sm mb-4 leading-relaxed">
              Get exclusive deals and outdoor living inspiration delivered to your inbox.
            </p>
            {submitted ? (
              <p className="text-[#7CB95A] text-sm font-medium">Thank you for subscribing!</p>
            ) : (
              <form onSubmit={handleSubscribe} data-readdy-form className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="Your email address"
                  className="flex-1 bg-white/10 border border-white/20 rounded-lg px-4 py-2.5 text-sm text-white placeholder-white/40 focus:outline-none focus:border-white/50 min-w-0"
                  required
                />
                <button
                  type="submit"
                  className="bg-[#4A7C2F] hover:bg-[#3d6826] text-white text-sm font-medium px-5 py-2.5 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </form>
            )}
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-white/40 text-xs text-center sm:text-left">
            <p>© 2026 ARAVELLA LLC. All rights reserved.</p>
            <p className="mt-1">2340 W Osborn Rd, Phoenix, AZ 85015 &nbsp;|&nbsp; <a href="mailto:aravellallc@outlook.com" className="hover:text-white/70 transition-colors">aravellallc@outlook.com</a></p>
          </div>
          <div className="flex items-center gap-4 text-white/40 text-xs">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
            <div className="flex items-center gap-1">
              <i className="ri-shield-check-line text-sm"></i>
              <span>Secure Checkout</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
